import React,{useState} from 'react'
import {Grid,Button,Pagination} from '@mui/material';
import './searchMainComp.css';
import { locations as cardLocations } from 'data/mock-data';
import CarouselCard from './CarouselCard';
import { FaFilter } from 'react-icons/fa';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

const SearchMainComp = () => {

  const [currentPage,setCurrentPage] = useState(1)
  var countLength = Math.ceil(cardLocations.length/8);

  const containerStyle = {
    width: '100%',
    height: '100%'
  };
  
  const center = {
    lat: -3.745,
    lng: -38.523
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "YOUR_API_KEY"
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])


  return (
    <div>
        
        <div className='searchPageCompMain'>
        <Grid container>
        <Grid item md={6} className='firstSearchPageCompSubMain'>
        <Grid container justifyContent={'space-between'} alignItems='center' mt={2} mb={2}>
            <span style={{color:'black',fontWeight:900}}>Over 1,000 stays</span>
            <Button
          sx={{
            display: { xs: 'none', md: 'flex' },
            border: '1px solid #ddd',
            minWidth: 90,
            fontWeight:900,
            justifyContent: 'center',
            borderRadius: 2,
            textTransform: 'capitalize',
            py: 1,
            color: 'theme.palette.text.primary',
          }}
        >
          <FaFilter style={{marginRight:6}} /> Filters
        </Button>
        </Grid>
        <Grid container rowSpacing={3} columnSpacing={3}>
        {cardLocations.map((location,i) => {
          if(i<currentPage*8 && i > ((currentPage-1)*8)-1 ){
          return (
            <Grid key={location.id} item xs={12} sm={4} md={6} lg={6}>
              <CarouselCard location={location} />
            </Grid>
          )};
        })}
        <div className='paginationDiv'>
        <Pagination count={countLength} page={currentPage} 
        onChange={(v,a)=>{
          setCurrentPage(Number(a)) 
        }}
        variant="outlined" />
        </div>
      </Grid>


        </Grid>
        <Grid item md={6}>
            <div className='mapDiv'>
        {
          isLoaded &&
        <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        // onUnmount={onUnmount}
      >
      </GoogleMap>
        }
            </div>
        </Grid>
        </Grid>
        </div>
    </div>
  )
}

export default SearchMainComp